<label class="label-form-control select-label"> {{ label }} </label>
<div
  class="form-control form-control-sm select-form-control"
  [matMenuTriggerFor]="matMenu"
  #t="matMenuTrigger"
  [ngClass]="{ disabled: menuDisabled, 'input-focus': t.menuOpen }"
>
  <div class="display">{{ selected?.name }}</div>
  <capra-icon class="select-icon" icon="icon-caret-down"></capra-icon>
</div>
<mat-menu #matMenu="matMenu" class="select-menu">
  <ng-template matMenuContent>
    <button
      mat-menu-item
      class="dropdown-menu-item"
      *ngFor="let item of menuItems; trackBy: trackByName"
      (click)="selectItem(item)"
      [autofocus]="item === selected"
      [disabled]="item.disabled"
    >
      <span [class.selected]="item === selected">
        <span class="indicator-icon"></span><span class="dropdown-menu-item-text"> {{ item.name }}</span>
      </span>
    </button>
  </ng-template>
</mat-menu>
